import { useState , useEffect } from 'react'
import styled from 'styled-components'
import { getGalleryEntries } from '../../api/firebase'
import ImageCard from '../ui/ImageCard'


const Wrapper = styled.div`
    
    .col_title{
        margin: 2rem 1rem;
        width: 100%;
        text-align: center;
        display: block;
        font-size: 2rem;
    }
    @media( min-width: 880px) {
        margin: 2rem 3rem;
    }
`

const Grid = styled.div`
    padding-top: 10px;
    display: grid;
    grid-template-columns: repeat(1,1fr);
    place-items: center;
    width: 90%;


    .media{
        margin: 1rem;
        height: 315px;
        width: 315px;
        margin-bottom: 4rem;
        img{
            width: 100%;
            height: 100%;
            object-fit: fill;
        }
        h4{
            color: #333;
            font-size: 26px;
            text-transform: uppercase;
            text-align: center;
        }
    }
    
    
    
    
    
    @media( min-width: 950px) {
        grid-template-columns: repeat(3,1fr);
        .media { height: 375px; width: 375px}
    }
    @media( min-width: 880px) {
        .media{ height: 315px;
        width: 315px; }
    }
    @media( min-width: 645px) {
        grid-template-columns: repeat(2,1fr);
    }

    @media ( min-width: 450px) { 
        grid-template-columns: repeat(1,1fr);
        .media { height: 375px; width: 375px}
    }

`






const Gallery = () => {
  const [images , setImages ] = useState([])
  const [ loading , setLoading ] = useState(true)

  useEffect(()=>{
    
    async function fetchImages(){
       try {
           const res = await getGalleryEntries()
           setImages(res)
           setLoading(false)
           
       } catch (error) {
           console.error(error)
       }

    }

    if(loading){
        fetchImages()
    }
  },[loading,images])

  const collections = new Set()
  images.forEach( img => collections.add(img.collection))

  return (
      <Wrapper>
          <h1>Gallery</h1>
          <Grid>
          { images
            .sort( (a,b) => {
                if(a.collection < b.collection ){
                    return -1
                }
                if(a.collection > b.collection ){
                    return 1
                }
                return 0
            })
            .map( img => ( 
              <ImageCard title={img.title} src={img.url} description={img.description} collection={img.collection}/>
            ))}
        </Grid>
      </Wrapper>

    
  )
}

export default Gallery